import { Component, OnInit } from '@angular/core';
import { DataTaskService } from '../../../core/services/data-task.service';
import { FormButton } from '../../../core/components/form-field-button/form-field-button.component';
import { GridOptions } from '../../../core/components/grid/grid.types';
import { Grid } from '../../../core/components/grid/grid.model';

@Component({
  selector: 'tt-counters',
  templateUrl: './counters.component.html',
  styleUrls: ['./counters.component.css']
})
export class CountersComponent implements OnInit {
    public searchTextButtons: FormButton[] = [{ id: 'search', icon: 'fas fa-search', type: 'primary', onClick: () => this.onSearchTextChanged() }];

    public setting?: Setting;

    public grid?: GridOptions;

    constructor(private datatask: DataTaskService) {

    }

    private async loadSetting() {
        this.setting = (await this.datatask.Post(2554))[0];
    }

    private loadGrid() {
        if (!this.grid) {
            this.grid = new Grid()
                .setRememberId('w_counters_grid')
                .setLoadDataFunction({
                    method: 2553,
                    parameters: () => this.setting
                })
                .setKendoConfig({ height: '100%' })
                .setToolbar({ wrapping: true });
        } else {
            this.grid?.gridfunc?.read();
        }
    }

    public async onSearchTextChanged() {
        if (!this.setting) return;

        this.searchTextButtons[0].icon = 'fas fa-spinner fa-spin';

        this.grid?.gridfunc?.read().then(() => this.searchTextButtons[0].icon = 'fas fa-search');
    }

    public onChanged(_: string, id: keyof Setting) {
        if (!this.setting) return;

        switch (id) {
            case 'searchtext':
                if (this.setting.searchtext === '') this.onSearchTextChanged();
                break;
            default:
                break;
        }
    }

    private async init() {
        await this.loadSetting();
        this.loadGrid();
    }

    ngOnInit() {
        this.init();
    }
}

interface Setting {
    searchtext: string;
}
